import React from "react";
import Navbar from "./components/Navbar";
import About from "./components/About";
import Features from "./components/Features";
import Advertisements from "./components/Advertisements";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

function App() {
  return (
    <div className="App">
      <Navbar />
      <main className="main">
        <About />
        <Features />
        <Advertisements />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
